import React from "react";
import { ChevronRight } from "lucide-react";
import ROUTES_CONFIG from "@/routes.json";

const SITE = ROUTES_CONFIG.site;

const pathFor = (page, language) => {
  const entry = ROUTES_CONFIG.pages.find((p) => p.page === page);
  if (!entry) return "/";
  return (language === "en" ? entry.en : entry.ro) || entry.ro;
};

// Canonical blog paths per language, resolved from the single source of truth (routes.json)
export const blogPaths = (language) => ({
  home: pathFor("home", language),
  blog: pathFor("blog", language),
  articles: pathFor("blog-articles", language),
  resources: pathFor("resources", language),
});

// items: [{ label, href }] — the last item is the current page and must have no href
export const Breadcrumbs = ({ items, className = "" }) => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.label,
      ...(item.href ? { item: SITE + (item.href === "/" ? "/" : item.href) } : {}),
    })),
  };

  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className={className}>
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[13px] text-sage-900/70">
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-x-2">
            {i > 0 && <ChevronRight size={13} strokeWidth={1.8} className="text-sage-900/30" />}
            {item.href ? (
              <a
                href={item.href}
                data-testid={`breadcrumb-link-${i}`}
                className="hover:text-sage transition-colors"
              >
                {item.label}
              </a>
            ) : (
              <span data-testid="breadcrumb-current" aria-current="page" className="text-sage-900/70">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
    </nav>
  );
};

export default Breadcrumbs;
